"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDefaultStateManager = createDefaultStateManager;
exports["default"] = createStates;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread6 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _utils = require("./utils");
function copy(obj) {
  var r = {};
  try {
    r = structuredClone(obj);
  } catch (e) {
    try {
      r = (0, _utils.copyObject)(obj);
    } catch (e) {}
  }
  return r;
}
function createDefaultStateManager() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  var defaultReducers = Object.create(Object.prototype, {
    req: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: function value() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments.length > 1 ? arguments[1] : undefined;
        switch (action.type) {
          case "SET_REQ":
            return (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, state), {}, (0, _defineProperty2["default"])({}, action.payload.name, action.payload.value && typeof action.payload.value == "object" ? (0, _utils.copyObject)(action.payload.value) : action.payload.value));
          default:
            return state;
        }
      }
    }),
    res: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: function value() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments.length > 1 ? arguments[1] : undefined;
        switch (action.type) {
          case "SET_RES":
            return (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, state), {}, (0, _defineProperty2["default"])({}, action.payload.name, action.payload.value && typeof action.payload.value == "object" ? (0, _utils.copyObject)(action.payload.value) : action.payload.value));
          case "INS_RES":
            if (typeof action.payload.value === "object" && action.payload.value && typeof state[action.payload.name] === "object" && state[action.payload.name]) {
              return (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, state), {}, (0, _defineProperty2["default"])({}, action.payload.name, (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, state[action.payload.name]), (0, _utils.copyObject)(action.payload.value))));
            }
            return (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, state), {}, (0, _defineProperty2["default"])({}, action.payload.name, action.payload.value && typeof action.payload.value == "object" ? (0, _utils.copyObject)(action.payload.value) : action.payload.value));
          default:
            return state;
        }
      }
    })
  });
  var defaultActions = Object.create(Object.prototype, {
    req: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: function value(_ref) {
        var name = _ref.name,
          _value = _ref.value;
        return {
          type: "SET_REQ",
          payload: {
            name: name,
            value: _value
          }
        };
      }
    }),
    res: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: function value(_ref2) {
        var type = _ref2.type,
          name = _ref2.name,
          _value2 = _ref2.value;
        return {
          type: type || "SET_RES",
          payload: {
            name: name,
            value: _value2
          }
        };
      }
    })
  });
  var defaultRootReducer = function defaultRootReducer(newState, action) {
    Object.keys(stateManager.reducers).forEach(function (key) {
      newState[key] = stateManager.reducers[key](newState[key], action);
    });
    return newState;
  };
  function createStore() {
    var rootReducer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRootReducer;
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var state = {};
    var cachedString = "";
    Object.keys(initialState).forEach(function (key) {
      state[key] = initialState[key];
    });
    return {
      getState: function getState(p) {
        var keys = p && typeof p == "string" ? p : p && typeof p == "object" && typeof p.keys == "string" ? p.keys : "";
        if (keys) {
          var _find = function find(keys, o) {
            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            if (keys[i + 1] && keys[i] && o[keys[i]] && typeof o[keys[i]] == "object") {
              _find(keys, o[keys[i]], i + 1);
            } else if (!keys[i + 1] && typeof o[keys[i]] !== "undefined") {
              found = o[keys[i]];
            }
          };
          var found;
          _find(keys.split("."), state);
          return typeof found === "object" && found ? copy(found) : found;
        }
        try {
          if (!cachedString) {
            cachedString = JSON.stringify(state);
          }
          return JSON.parse(cachedString);
        } catch (e) {
          console.log(e);
          state = {};
          Object.keys(initialState).forEach(function (key) {
            state[key] = initialState[key];
          });
          cachedString = JSON.stringify(state);
          return JSON.parse(cachedString);
        }
      },
      dispatch: function dispatch(action) {
        try {
          rootReducer(state, action);
        } catch (e) {
          console.log(e);
        }
        cachedString = "";
        try {
          stateManager.runListeners(action);
        } catch (e) {
          console.log(e);
        }
      },
      subscribe: function subscribe(listener) {
        return stateManager.addListener(listener);
      }
    };
  }
  function defaultAddListener(listener) {
    stateManager.listeners.push(listener);
    return function unsubscribe() {
      stateManager.removeListener(listener);
    };
  }
  function defaultRemoveListener(listener) {
    if (stateManager.listeners.indexOf(listener) !== -1) {
      stateManager.listeners.splice(stateManager.listeners.indexOf(listener), 1);
    }
  }
  function defaultRunListeners(action) {
    var listeners = (0, _toConsumableArray2["default"])(stateManager.listeners);
    listeners.forEach(function (listener) {
      listener(action);
    });
  }
  var stateManager = Object.create(Object.prototype, {
    wapp: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      enumerable: false,
      value: wapp
    }),
    reducers: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultReducers
    }),
    rootReducer: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultRootReducer
    }),
    actions: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultActions
    }),
    createStore: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: createStore
    }),
    listeners: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: []
    }),
    addListener: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAddListener
    }),
    removeListener: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultRemoveListener
    }),
    runListeners: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultRunListeners
    })
  });
  return stateManager;
}
function createStates() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp,
    _p$stateManager = p.stateManager,
    stateManager = _p$stateManager === void 0 ? createDefaultStateManager(p) : _p$stateManager;
  function addSomePropertyToClientAppFromInitialState(req, res, next) {
    // the client can't set this properties from the window location,
    // so if the server sent these data, then these are setting here to app.req and wappRequest:
    // method, httpVersion, remoteAddress

    // req.timestamp, res.statusCode, statusMessage, errorMessage will update in every client side update,
    // but the first render need this data from the server

    if (wapp.target === "web") {
      var wappResponse = res.wappResponse;
      var wappRequest = req.wappRequest;
      var appStateName = wappResponse.appStateName;
      var initialState = window[appStateName];
      if (initialState) {
        var reqFromState = initialState.req || {};
        var resFromState = initialState.res || {};
        req.httpVersion = reqFromState.httpVersion || "1.1";
        req.method = reqFromState.method || req.method;
        req.remoteAddress = reqFromState.remoteAddress || req.remoteAddress;
        wappRequest.method = req.method;
        wappRequest.httpVersion = req.httpVersion;
        wappRequest.remoteAddress = req.remoteAddress;
        if (statesMiddleware.shouldInitializedStore) {
          req.timestamp = reqFromState.timestamp || req.timestamp;
          wappRequest.timestamp = req.timestamp;
          res.statusCode = resFromState.statusCode || res.statusCode;
          wappResponse.statusCode = res.statusCode;
          res.statusMessage = resFromState.statusMessage || res.statusMessage;
          wappResponse.statusMessage = res.statusMessage;
          res.errorMessage = resFromState.errorMessage || res.errorMessage;
          wappResponse.errorMessage = res.errorMessage;
        }
      }
    }
    next();
  }
  var lastStoreForClient = null;
  function defaultStatesForReqRes(req, res, next) {
    var wappRequest = req.wappRequest;
    var wappResponse = res.wappResponse;
    var timestamp = wappRequest.timestamp;
    var path = wappRequest.path;
    var url = wappRequest.url;
    var method = wappRequest.method;
    var httpVersion = wappRequest.httpVersion;
    var hostname = wappRequest.hostname;
    var protocol = wappRequest.protocol;
    var secure = wappRequest.secure;
    var remoteAddress = wappRequest.remoteAddress;
    var userAgent = wappRequest.userAgent;
    var query = wappRequest.query;
    var statusCode = wappResponse.statusCode;
    var statusMessage = wappResponse.statusMessage;
    var errorMessage = wappResponse.errorMessage;
    var containerElementId = wappResponse.containerElementId;
    var appStateName = wappResponse.appStateName;
    var initState = wapp.target === "web" && window[appStateName] ? window[appStateName] : {
      req: {
        timestamp: timestamp,
        path: path,
        url: url,
        method: method,
        httpVersion: httpVersion,
        hostname: hostname,
        protocol: protocol,
        secure: secure,
        remoteAddress: remoteAddress,
        userAgent: userAgent,
        query: query
      },
      res: {
        statusCode: statusCode,
        statusMessage: statusMessage,
        errorMessage: errorMessage,
        containerElementId: containerElementId,
        appStateName: appStateName
      }
    };
    var init = statesMiddleware.shouldInitializedStore;
    var store = init ? wapp.states.stateManager.createStore(wapp.states.stateManager.rootReducer, initState) : wappResponse.store;
    if (init) {
      Object.defineProperty(wappResponse, "store", {
        writable: true,
        enumerable: true,
        configurable: false,
        value: store
      });
      if (wapp.target === "web") {
        lastStoreForClient = wappResponse.store;
      }
    }
    if (!init || init && initState.req.timestamp !== timestamp) {
      if (store.getState("req.timestamp") !== timestamp) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "timestamp",
          value: timestamp
        }));
      }
    }
    if (!init || init && initState.req.path !== path) {
      if (store.getState("req.path") !== path) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "path",
          value: path
        }));
      }
    }
    if (!init || init && initState.req.url !== url) {
      if (store.getState("req.url") !== url) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "url",
          value: url
        }));
      }
    }
    if (!init || init && initState.req.method !== method) {
      if (store.getState("req.method") !== method) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "method",
          value: method
        }));
      }
    }
    if (!init || init && initState.req.httpVersion !== httpVersion) {
      if (store.getState("req.httpVersion") !== httpVersion) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "httpVersion",
          value: httpVersion
        }));
      }
    }
    if (!init || init && initState.req.hostname !== hostname) {
      if (store.getState("req.hostname") !== hostname) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "hostname",
          value: hostname
        }));
      }
    }
    if (!init || init && initState.req.protocol !== protocol) {
      if (store.getState("req.protocol") !== protocol) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "protocol",
          value: protocol
        }));
      }
    }
    if (!init || init && initState.req.secure !== secure) {
      if (store.getState("req.secure") !== secure) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "secure",
          value: secure
        }));
      }
    }
    if (!init || init && initState.req.remoteAddress !== remoteAddress) {
      if (store.getState("req.remoteAddress") !== remoteAddress) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "remoteAddress",
          value: remoteAddress
        }));
      }
    }
    if (!init || init && initState.req.userAgent !== userAgent) {
      if (store.getState("req.userAgent") !== userAgent) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "userAgent",
          value: userAgent
        }));
      }
    }
    if (!init || init && initState.req.query !== query) {
      if (store.getState("req.query") !== query) {
        wappResponse.store.dispatch(wapp.states.runAction("req", {
          name: "query",
          value: query
        }));
      }
    }
    if (!init || init && initState.res.statusCode !== statusCode) {
      if (store.getState("res.statusCode") !== statusCode) {
        wappResponse.store.dispatch(wapp.states.runAction("res", {
          name: "statusCode",
          value: statusCode
        }));
      }
    }
    if (!init || init && initState.res.statusMessage !== statusMessage) {
      if (store.getState("res.statusMessage") !== statusMessage) {
        wappResponse.store.dispatch(wapp.states.runAction("res", {
          name: "statusMessage",
          value: statusMessage
        }));
      }
    }
    if (!init || init && initState.res.errorMessage !== errorMessage) {
      if (store.getState("res.errorMessage") !== errorMessage) {
        wappResponse.store.dispatch(wapp.states.runAction("res", {
          name: "errorMessage",
          value: errorMessage
        }));
      }
    }
    if (!init || init && initState.res.appStateName !== appStateName) {
      if (store.getState("res.appStateName") !== appStateName) {
        wappResponse.store.dispatch(wapp.states.runAction("res", {
          name: "appStateName",
          value: appStateName
        }));
      }
    }
    if (!init || init && initState.res.containerElementId !== containerElementId) {
      if (store.getState("res.containerElementId") !== containerElementId) {
        wappResponse.store.dispatch(wapp.states.runAction("res", {
          name: "containerElementId",
          value: containerElementId
        }));
      }
    }
    next();
  }
  function defaultHandle(req, res, out) {
    var statesMiddlewares = Object.keys(statesMiddleware.handles).sort().map(function (key) {
      return statesMiddleware.handles[key];
    });
    var index = 0;
    function next(err) {
      if (statesMiddlewares[index]) {
        var func = statesMiddlewares[index];
        index = index + 1;
        return func(req, res, err ? function () {
          next(err);
        } : next);
      } else if (typeof out === "function") {
        index = 0;
        return out(err);
      }
      return null;
    }
    return next();
  }
  function defaultAddHandle(obj) {
    if (typeof obj === "object" && !obj.length) {
      Object.keys(obj).forEach(function (handleName) {
        var handle = obj[handleName];
        if (typeof handle == "function") {
          statesMiddleware.handles[handleName] = handle;
        }
      });
    }
  }
  function defaultRunAction(actionName, props) {
    return statesMiddleware.stateManager.actions[actionName](props);
  }
  var statesMiddlewareProperties = Object.create(Object.prototype, {
    handle: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultHandle
    }),
    handles: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: {
        clientapp: addSomePropertyToClientAppFromInitialState,
        reqres: defaultStatesForReqRes
      }
    }),
    stateManager: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: stateManager
    }),
    addHandle: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAddHandle
    }),
    runAction: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultRunAction
    }),
    shouldInitializedStore: (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
      value: false
    })
  });
  function statesMiddleware(req, res, out) {
    if (typeof statesMiddleware.handle === "function") {
      if (!res.wappResponse.store && wapp.target === "web" && lastStoreForClient) {
        res.wappResponse.store = lastStoreForClient;
      }
      statesMiddleware.shouldInitializedStore = wapp.target === "node" || !res.wappResponse.store;
      statesMiddleware.handle(req, res, function next() {
        statesMiddleware.shouldInitializedStore = wapp.target === "node" || !res.wappResponse.store;
        out();
      });
    }
    return statesMiddleware;
  }
  (0, _utils.mergeProperties)(statesMiddleware, statesMiddlewareProperties);
  Object.defineProperty(statesMiddleware, "wapp", (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  Object.defineProperty(wapp, "states", (0, _objectSpread6["default"])((0, _objectSpread6["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    value: statesMiddleware
  }));
  return statesMiddleware;
}